module.exports = {"title":"비밀번호 변경 - 고고밴","password_headline":"비밀번호 변경","password_email":"등록되어 있는 이메일 주소","password_password":"신규 비밀번호","password_confirm_password":"비밀번호 확인","password_button_request_reset":"비밀번호 변경 신청","password_button_submit":"확인","password_respond":"신청이 완료되었습니다. 이메일을 확인해주세요","password_email_not_found":"등록되지 않은 이메일입니다, <a href=\"#register\" class=\"global-text-blue dialog\">가입 후</a> 진행해주세요.","password_error_password_length":"최소 8자리 이상의 비밀번호를 입력해주세요.","password_error_password_equal":"비밀번호가 일치하지 않습니다.","password_error_token_expired":"만료된 링크입니다."}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/kr/setting/password/locale.json
// module id = 680
// module chunks = 0 1 2 3 4 5